import styled from 'styled-components'

export default styled.button`
  display: block;
  margin: auto;
  border: none;
  background-color: transparent;
  font-family: 'ABChanel PB Regular S', Arial, sans-serif;
  font-size: 12px;
  letter-spacing: -0.025em;
  padding: 16px 32px;
  background-color: #000000;
  color: #ffffff;
  html[lang=tw] & {
    font-size: 14px;
  }
`



// WEBPACK FOOTER //
// ./src/styles/BrowseAllProductsBtn.js